import { ItemStatus } from '../../../../enums/ItemStatus';
import { NodeType } from '../../../../enums/NodeType';
import { Role } from '../../../../enums/Role';
import {
  getInvalidItemDataReference,
  getItemStatusId,
  getSchema
} from '../../../../utils';
import { GetPermissionFn } from '../types';

export const getCommentWidgetPermission: GetPermissionFn = ({
  hasRole,
  workspace,
  data
}) => {
  if (!data) return { canView: false, canEdit: false };

  if (hasRole(Role.planningReadonly)) {
    return { canView: true, canEdit: false };
  }

  if (data?.labels?.includes(NodeType.Item) && data.props?.itemId) {
    const statusId = getItemStatusId(data);
    if ([ItemStatus.Removed].includes(statusId)) {
      return { canView: true, canEdit: false };
    }
  } else if (data?.labels?.includes(NodeType.Item)) {
    const statusId = getItemStatusId(data);
    if ([ItemStatus.Retired].includes(statusId)) {
      return { canView: true, canEdit: false };
    }
  }

  const itemSchema = getSchema(workspace.schemas, NodeType.Item);
  const invalidWorkspaceDataRef = getInvalidItemDataReference(
    workspace,
    itemSchema,
    data
  );
  if (invalidWorkspaceDataRef != null) {
    return { canView: true, canEdit: false };
  }

  return { canView: true, canEdit: true };
};
